import { getCookie } from '@miro-site/utils-storage';
export default getCookie;